import type { RootState } from "@/app/store";

export function selectZoom(state: RootState) { return state.settings.zoom; }
export function selectTheme(state: RootState) { return state.settings.theme; }
export function selectShowImages(state: RootState) { return state.settings.showImages; }
export function selectFinanceScope(state: RootState) { return state.settings.financeScope; }
export function selectActiveProjectId(state: RootState) {
  const scope = state.settings.financeScope;
  return typeof scope === "number" ? scope : null;
}
export function selectSidebarCollapsed(state: RootState) { return state.settings.sidebarCollapsed; }

